import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faPencilAlt,
  faPlus,
  faTrash
} from '@fortawesome/free-solid-svg-icons';
import { KeycloakProfile } from 'keycloak-js';

type EventOperationType = 'CREATE' | 'UPDATE' | 'DELETE' | 'REGISTER';
export type EventoKeycloakDTO = {
  id: string;

  time: number;

  timestamp: string;

  realmId: string;

  operationType: EventOperationType;

  resourceType: string;

  resourcePath: string;

  representation: KeycloakProfile;

  error: string;

  clientId: string;
  username: string;
  fullName: string;
  email: string;
  userId: string;
  userRealm: string;
  ipAddress: string;
};

export const TipoEventoKeycloakLabels: Record<EventOperationType, string> = {
  CREATE: 'Adição',
  UPDATE: 'Edição',
  DELETE: 'Remoção',
  REGISTER: 'Adição'
};

export const TipoEventoKeycloakMap: Record<
  EventOperationType,
  {
    icon: IconProp;
    color: 'module-color' | 'negative' | 'positive' | 'warning' | 'neutral';
  }
> = {
  CREATE: { icon: faPlus, color: 'positive' },
  REGISTER: { icon: faPlus, color: 'positive' },
  UPDATE: { icon: faPencilAlt, color: 'warning' },
  DELETE: { icon: faTrash, color: 'negative' }
};
